//русский

import ModalForm from "./ModalForm";

export { ModalForm };
